
































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Wall } from 'types'
import OzConfirmationDialogBox, {
  OzConfirmationDialogBoxButtonScheme,
} from 'library/v4/components/OzConfirmationDialogBox.vue'
import OzDrawerConfirmationDialog from 'library/v4/components/OzDrawerConfirmationDialog.vue'
import OzLargeConfirmationDialog from 'library/v4/components/OzLargeConfirmationDialog.vue'
import OzOverlay from 'library/v4/components/OzOverlay.vue'
import OzWallListRow, { OzListRowSeparator } from 'library/v4/components/OzWallListRow.vue'
import { ConfirmationDialogLayoutVariant } from 'vuexstore/modules/global_confirmation_dialog'

const confirmationDialog = namespace('confirmationDialog')

@Component({
  components: {
    OzConfirmationDialogBox,
    OzDrawerConfirmationDialog,
    OzLargeConfirmationDialog,
    OzOverlay,
    OzWallListRow,
  },
})
export default class GlobalConfirmationDialog extends Mixins() {
  ConfirmationDialogLayoutVariant = ConfirmationDialogLayoutVariant
  OzListRowSeparator = OzListRowSeparator

  $refs!: {
    dialogBox: OzConfirmationDialogBox
  }

  // This component comes as a pair with the vuexstore/modules/global_confirmation_dialog.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @confirmationDialog.State isOpen!: boolean
  @confirmationDialog.State layoutVariant!: boolean
  @confirmationDialog.State subject!: null | { wall: Wall }
  @confirmationDialog.State title!: string
  @confirmationDialog.State body!: string
  @confirmationDialog.State isCodeProtected!: boolean
  @confirmationDialog.State confirmButtonText!: string
  @confirmationDialog.State cancelButtonText!: string
  @confirmationDialog.State iconSrc!: string | null
  @confirmationDialog.State iconAlt!: string | null
  @confirmationDialog.State buttonScheme!: OzConfirmationDialogBoxButtonScheme
  @confirmationDialog.State forceFullWidthButtons!: boolean
  @confirmationDialog.State xShadow!: boolean
  @confirmationDialog.State shouldFadeIn!: boolean
  @confirmationDialog.Action cancel!: () => void
  @confirmationDialog.Action confirm!: () => void

  @Watch('isOpen', { immediate: true })
  respondToDialogOpened(newIsOpen: boolean): void {
    if (newIsOpen) this.$nextTick(() => this.$refs?.dialogBox?.focus())
  }
}
